var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 65,
    viewBox: "0 0 70 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7884 9.95777C38.0313 3.08939 28.2797 3.14462 26.3756 10.0394L23.8585 19.1535L14.1916 19.2083C6.7498 19.2504 4.3276 28.8322 10.6923 33.0504L18.5773 38.276L16.1733 46.9806C14.2522 53.9366 22.5118 59.8015 28.2716 55.5714L36.0519 49.8573L44.5348 55.4792C50.8146 59.6412 58.3418 53.6868 55.5603 46.7575L52.0795 38.0863L59.3115 32.7749C65.1492 28.4876 61.5416 18.94 54.0998 18.9822L44.4329 19.037L40.7884 9.95777Z",
    fill: "#846C3D",
    stroke: "#84858D",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowStar);
export default __webpack_public_path__ + "static/media/yellowStar.475ac7ba761a6d5fe0b69d291431adce.svg";
export { ForwardRef as ReactComponent };